import { useNavigate } from 'react-router-dom';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import EditIcon from '@mui/icons-material/Edit';
import Iconify from '../../ui-component/iconify';
import TableStyle from '../../ui-component/TableStyle';
import { useState } from 'react';
import {
  Stack,
  Button,
  Container,
  Typography,
  Box,
  Card,
  Popover,
  Chip,
  Paper,
  Grid,
  Avatar,
  alpha,
  useTheme,
  IconButton,
  MenuItem
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import * as React from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useEffect } from 'react';
import { getApi } from 'views/services/api';
import DeleteCustomer from './DeleteCustomer';
import AddCustomer from './AddCustomer.js';
import EditCustomer from './EditCustomer';
import {
  People as PeopleIcon,
  Person as PersonIcon,
  Phone as PhoneIcon,
  LocationOn as LocationIcon,
  CreditCard as CreditCardIcon,
  Badge as BadgeIcon,
  Visibility as ViewIcon,
  Edit as EditActionIcon,
  Delete as DeleteActionIcon,
  TrendingUp as TrendingUpIcon,
  PersonAdd as PersonAddIcon,
  ContactPhone as ContactPhoneIcon
} from '@mui/icons-material';

// ----------------------------------------------------------------------

const Customer = () => {
  const theme = useTheme();
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);

  const [customerData, setcustomerData] = useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const hotel = JSON.parse(localStorage.getItem('hotelData'));
  const navigate = useNavigate();

  const [rowData, setRowData] = useState();

  //function for the dropdowns

  const handleClick = (event, row) => {
    setAnchorEl(event.currentTarget);
    setRowData(row);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  // function for fetching all the customers data from the db

  const fetchcustomerData = async () => {
    try {
      // const response = await getApi(`api/customer/viewallcustomer/${hotel?._id}`);
      const response = await getApi(`api/customer/viewallcustomer/${hotel?.hotelId}`);
      console.log('response ==>', response);

      setcustomerData(response?.data?.customerData);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchcustomerData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openAdd, openEdit, openDelete]);

  //functions for dialog boxes----------------------------------
  const handleOpenAdd = () => setOpenAdd(true);
  const handleCloseAdd = () => setOpenAdd(false);

  // edit customer dialog
  const handleOpenEditCustomer = () => {
    setOpenEdit(true);
  };
  const handleCloseEditCustomer = () => {
    setOpenEdit(false);
    handleClose();
  };

  // delete customer dialog
  const handleOpenDeleteCustomer = () => {
    setOpenDelete(true);
  };
  const handleCloseDeleteCustomer = () => {
    setOpenDelete(false);
    handleClose();
  };

  // open view customers
  const handleOpenview = () => {
    navigate(`/dashboard/customer/view/${rowData?._id}`);
  };

  // Función para obtener las iniciales del nombre
  const getInitials = (name) => {
    if (!name) return '?';
    const nameParts = name.split(' ');
    if (nameParts.length >= 2) {
      return `${nameParts[0].charAt(0)}${nameParts[1].charAt(0)}`.toUpperCase();
    }
    return name.charAt(0).toUpperCase();
  };

  // Función para obtener color del avatar
  const getAvatarColor = (name) => {
    const colors = [
      theme.palette.primary.main,
      theme.palette.secondary.main,
      theme.palette.error.main,
      theme.palette.warning.main,
      theme.palette.info.main,
      theme.palette.success.main
    ];
    if (!name) return colors[0];
    const index = name.charCodeAt(0) % colors.length;
    return colors[index];
  };

  // Función para obtener el tipo de documento en español
  const getIdCardType = (type) => {
    const types = {
      passport: 'Pasaporte',
      dni: 'DNI',
      license: 'Licencia',
      id: 'Cédula',
      other: 'Otro'
    };
    return types[type?.toLowerCase()] || type || 'No especificado';
  };

  // Calcular estadísticas
  const totalCustomers = customerData?.length || 0;
  const customersWithPhone = customerData?.filter((customer) => customer.phoneNumber)?.length || 0;
  const customersWithId = customerData?.filter((customer) => customer.idcardNumber)?.length || 0;

  //---------------------------------------------------------------------
  const columns = [
    {
      field: `fullName`,
      headerName: 'Cliente',
      flex: 1.5,
      cellClassName: 'name-column--cell name-column--cell--capitalize',
      renderCell: (params) => {
        const avatarColor = getAvatarColor(params.value);
        return (
          <Box onClick={() => navigate(`/dashboard/customer/view/${params.row._id}`)} sx={{ cursor: 'pointer' }}>
            <Stack direction="row" alignItems="center" spacing={1.5}>
              <Avatar
                sx={{
                  width: 40,
                  height: 40,
                  bgcolor: alpha(avatarColor, 0.1),
                  color: avatarColor,
                  fontSize: '0.875rem',
                  fontWeight: 600,
                  border: `2px solid ${alpha(avatarColor, 0.2)}`
                }}
              >
                {getInitials(params.value)}
              </Avatar>
              <Box>
                <Typography
                  variant="body2"
                  fontWeight={600}
                  sx={{
                    '&:hover': {
                      color: theme.palette.primary.main
                    }
                  }}
                >
                  {params.value}
                </Typography>
                <Stack direction="row" alignItems="center" spacing={0.5}>
                  <PhoneIcon sx={{ fontSize: 12, color: theme.palette.text.secondary }} />
                  <Typography variant="caption" color="text.secondary">
                    {params.row.phoneNumber}
                  </Typography>
                </Stack>
              </Box>
            </Stack>
          </Box>
        );
      }
    },

    {
      field: 'phoneNumber',
      headerName: 'Teléfono',
      flex: 1,
      renderCell: (params) => (
        <Box display="flex" alignItems="center">
          <ContactPhoneIcon sx={{ fontSize: 16, mr: 1, color: theme.palette.info.main }} />
          <Typography variant="body2" fontWeight={500}>
            {params.value || 'No registrado'}
          </Typography>
        </Box>
      )
    },
    {
      field: 'address',
      headerName: 'Dirección',
      flex: 1.3,
      renderCell: (params) => (
        <Stack direction="row" alignItems="center" spacing={0.5}>
          <LocationIcon sx={{ fontSize: 14, color: theme.palette.text.secondary }} />
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
          >
            {params.value || 'No especificada'}
          </Typography>
        </Stack>
      )
    },
    {
      field: 'idCardType',
      headerName: 'Tipo de ID',
      flex: 1,
      renderCell: (params) => (
        <Chip
          label={getIdCardType(params.value)}
          size="small"
          variant="outlined"
          color="primary"
          icon={<CreditCardIcon sx={{ fontSize: 14 }} />}
          sx={{
            borderRadius: 2,
            fontWeight: 500,
            fontSize: '0.75rem'
          }}
        />
      )
    },
    {
      field: 'idcardNumber',
      headerName: 'Número de ID',
      flex: 1.2,
      renderCell: (params) => (
        <Box display="flex" alignItems="center">
          <BadgeIcon sx={{ fontSize: 14, mr: 0.5, color: theme.palette.text.secondary }} />
          <Typography variant="body2" fontFamily="monospace" fontWeight={500}>
            {params.value || 'No registrado'}
          </Typography>
        </Box>
      )
    },

    {
      field: 'action',
      headerName: 'Acciones',
      flex: 0.8,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => {
        return (
          <Box>
            <IconButton
              aria-describedby={params?.row._id}
              variant="contained"
              onClick={(event) => handleClick(event, params?.row)}
              sx={{
                bgcolor: alpha(theme.palette.primary.main, 0.1),
                '&:hover': {
                  bgcolor: alpha(theme.palette.primary.main, 0.2)
                }
              }}
            >
              <MoreVertIcon sx={{ color: theme.palette.primary.main }} />
            </IconButton>
            <Popover
              id={params?.row._id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left'
              }}
              PaperProps={{
                sx: {
                  borderRadius: 2,
                  boxShadow: theme.shadows[8],
                  border: `1px solid ${alpha(theme.palette.divider, 0.1)}`
                }
              }}
            >
              <MenuItem
                onClick={() => handleOpenEditCustomer()}
                disableRipple
                sx={{
                  py: 1.5,
                  px: 2,
                  '&:hover': {
                    bgcolor: alpha(theme.palette.primary.main, 0.05)
                  }
                }}
              >
                <EditActionIcon sx={{ mr: 1.5, fontSize: 18, color: theme.palette.primary.main }} />
                <Typography variant="body2" fontWeight={500}>
                  Editar
                </Typography>
              </MenuItem>
              <MenuItem
                onClick={() => handleOpenview(params.row._id)}
                disableRipple
                sx={{
                  py: 1.5,
                  px: 2,
                  '&:hover': {
                    bgcolor: alpha(theme.palette.success.main, 0.05)
                  }
                }}
              >
                <ViewIcon sx={{ mr: 1.5, fontSize: 18, color: theme.palette.success.main }} />
                <Typography variant="body2" fontWeight={500}>
                  Ver Detalles
                </Typography>
              </MenuItem>
              <MenuItem
                onClick={() => handleOpenDeleteCustomer()}
                disableRipple
                sx={{
                  py: 1.5,
                  px: 2,
                  '&:hover': {
                    bgcolor: alpha(theme.palette.error.main, 0.05)
                  }
                }}
              >
                <DeleteActionIcon sx={{ mr: 1.5, fontSize: 18, color: theme.palette.error.main }} />
                <Typography variant="body2" fontWeight={500} color="error">
                  Eliminar
                </Typography>
              </MenuItem>
            </Popover>
          </Box>
        );
      }
    }
  ];

  return (
    <>
      <AddCustomer open={openAdd} handleClose={handleCloseAdd} />
      <DeleteCustomer open={openDelete} handleClose={handleCloseDeleteCustomer} id={rowData?.phoneNumber} />
      <EditCustomer open={openEdit} handleClose={handleCloseEditCustomer} data={rowData} />

      <Container maxWidth="xl" sx={{ py: 3 }}>
        {/* Header Section */}
        <Paper
          elevation={0}
          sx={{
            p: 3,
            mb: 3,
            background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
            color: 'white',
            borderRadius: 3
          }}
        >
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Box>
              <Typography variant="h4" fontWeight={700} gutterBottom>
                Base de Clientes
              </Typography>
              <Typography variant="body1" sx={{ opacity: 0.9 }}>
                Gestiona la información de todos los clientes del hotel
              </Typography>
            </Box>
            <Box sx={{ display: { xs: 'none', md: 'block' } }}>
              <PeopleIcon sx={{ fontSize: 60, opacity: 0.3 }} />
            </Box>
          </Stack>
        </Paper>

        {/* Statistics Cards */}
        <Grid container spacing={3} sx={{ mb: 3 }}>
          <Grid item xs={12} sm={4}>
            <Card
              sx={{
                p: 2.5,
                borderRadius: 3,
                border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: theme.shadows[8]
                }
              }}
            >
              <Stack direction="row" alignItems="center" spacing={2}>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: 2,
                    backgroundColor: alpha(theme.palette.primary.main, 0.1),
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <PersonIcon sx={{ color: theme.palette.primary.main, fontSize: 24 }} />
                </Box>
                <Box>
                  <Typography variant="h6" fontWeight={600} color="primary">
                    {totalCustomers}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Total de Clientes
                  </Typography>
                </Box>
              </Stack>
            </Card>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Card
              sx={{
                p: 2.5,
                borderRadius: 3,
                border: `1px solid ${alpha(theme.palette.info.main, 0.1)}`,
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: theme.shadows[8]
                }
              }}
            >
              <Stack direction="row" alignItems="center" spacing={2}>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: 2,
                    backgroundColor: alpha(theme.palette.info.main, 0.1),
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <PhoneIcon sx={{ color: theme.palette.info.main, fontSize: 24 }} />
                </Box>
                <Box>
                  <Typography variant="h6" fontWeight={600} color="info.main">
                    {customersWithPhone}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Con Teléfono
                  </Typography>
                </Box>
              </Stack>
            </Card>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Card
              sx={{
                p: 2.5,
                borderRadius: 3,
                border: `1px solid ${alpha(theme.palette.success.main, 0.1)}`,
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: theme.shadows[8]
                }
              }}
            >
              <Stack direction="row" alignItems="center" spacing={2}>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: 2,
                    backgroundColor: alpha(theme.palette.success.main, 0.1),
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <CreditCardIcon sx={{ color: theme.palette.success.main, fontSize: 24 }} />
                </Box>
                <Box>
                  <Typography variant="h6" fontWeight={600} color="success.main">
                    {customersWithId}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Con Identificación
                  </Typography>
                </Box>
              </Stack>
            </Card>
          </Grid>
        </Grid>

        {/* Controls Section */}
        <Card sx={{ p: 3, mb: 3, borderRadius: 3, border: `1px solid ${alpha(theme.palette.divider, 0.1)}` }}>
          <Stack direction={{ xs: 'column', sm: 'row' }} alignItems="center" spacing={2} justifyContent="space-between">
            <Box>
              <Typography variant="h6" fontWeight={600}>
                Gestión de Clientes
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Agrega, edita o consulta la información de tus clientes
              </Typography>
            </Box>

            <Button
              variant="contained"
              startIcon={<PersonAddIcon />}
              onClick={handleOpenAdd}
              sx={{
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 600,
                px: 3,
                py: 1.2,
                boxShadow: theme.shadows[3],
                '&:hover': {
                  boxShadow: theme.shadows[6]
                }
              }}
            >
              Nuevo Cliente
            </Button>
          </Stack>
        </Card>

        {/* Data Table */}
        <TableStyle>
          <Card
            sx={{
              borderRadius: 3,
              overflow: 'hidden',
              border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
              '& .MuiDataGrid-root': {
                border: 'none',
                '& .MuiDataGrid-columnHeaders': {
                  backgroundColor: alpha(theme.palette.primary.main, 0.05),
                  borderBottom: `2px solid ${alpha(theme.palette.primary.main, 0.1)}`,
                  '& .MuiDataGrid-columnHeader': {
                    fontWeight: 600,
                    fontSize: '0.875rem'
                  }
                },
                '& .MuiDataGrid-row': {
                  '&:hover': {
                    backgroundColor: alpha(theme.palette.primary.main, 0.02)
                  }
                },
                '& .MuiDataGrid-cell': {
                  borderBottom: `1px solid ${alpha(theme.palette.divider, 0.05)}`
                }
              }
            }}
          >
            <Box sx={{ p: 3, pb: 1 }}>
              <Typography variant="h6" fontWeight={600} color="primary">
                Lista de Clientes ({totalCustomers})
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Haz clic en un cliente para ver su perfil completo
              </Typography>
            </Box>

            <Box sx={{ height: 600, width: '100%' }}>
              {customerData && (
                <DataGrid
                  rows={customerData}
                  columns={columns}
                  checkboxSelection
                  getRowId={(row) => row?._id}
                  slots={{ toolbar: GridToolbar }}
                  slotProps={{
                    toolbar: {
                      showQuickFilter: true,
                      quickFilterProps: {
                        debounceMs: 500,
                        placeholder: 'Buscar clientes...'
                      }
                    }
                  }}
                  sx={{
                    '& .MuiDataGrid-toolbarContainer': {
                      borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                      p: 2
                    }
                  }}
                />
              )}
            </Box>
          </Card>
        </TableStyle>
      </Container>
    </>
  );
};

export default Customer;
